import { Box, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
// import CloudProviderBarSkeleton from "@root/components/v2/content/CloudProviderBar/skeleton";
import PageContent from '@root/components/v2/layout/PageContent';

function ReportSkeleton() {
  return (
    <PageContent>
      <Skeleton
        variant="rectangular"
        height="15px"
        width={'100px'}
        sx={{ marginBottom: '15px', borderRadius: '8px' }}
      />
      {/* <CloudProviderBarSkeleton /> */}

      {/* <ContentBox paddingMode="content" marginBottom="15px"> */}
      <Box className="Borders RoundedCorners" marginBottom="15px" marginTop="15px">
        <Skeleton height="40px" style={{ transform: 'none' }} />
      </Box>

      <Box height={'63.7vh'}>
        <TableSkeleton />
      </Box>
      {/* </ContentBox> */}
    </PageContent>
  );
}

export default ReportSkeleton;
